import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

const CaisseStockModal = ({ show, onClose, product, caisses, caisseStocks }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {t("Stock par caisse")} - {product.titre?.fr || product.titre}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info mb-4">
          <strong>{t("Stock principal")}:</strong> {product.stock?.quantite_stock || 0} unités
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t("Caisse")}</th>
              <th>{t("Emplacement")}</th>
              <th>{t("Quantité")}</th>
              <th>{t("Statut")}</th>
            </tr>
          </thead>
          <tbody>
            {caisses.map((caisse) => {
              const stock = caisseStocks[caisse._id]?.find(
                (s) => s.product_id === product._id
              );
              const quantity = stock?.quantite_stock || 0;
              const alertThreshold = stock?.quantite_alerte || 5;
              
              let status = "normal";
              if (quantity <= 0) {
                status = "rupture";
              } else if (quantity <= alertThreshold) {
                status = "bas";
              }

              return (
                <tr key={caisse._id}>
                  <td>{caisse.nom}</td>
                  <td>{stock?.emplacement || "Non défini"}</td>
                  <td>
                    <span className={`badge badge-${
                      status === "rupture" ? "danger" : 
                      status === "bas" ? "warning" : "success"
                    }`}>
                      {quantity}
                    </span>
                  </td>
                  <td>
                    {status === "rupture" && t("Rupture")}
                    {status === "bas" && t("Stock bas")}
                    {status === "normal" && t("Normal")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {product.stock?.date_derniere_mise_a_jour && (
          <div className="text-muted mt-3">
            <small>
              {t("Dernière mise à jour")}: {new Date(product.stock.date_derniere_mise_a_jour).toLocaleString()}
            </small>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("Fermer")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CaisseStockModal;